type FormikErrors = {
  [key: string]: string;
};

const hasFieldErrors = (errors: FormikErrors, fields: string[] = []) => {
  if (!errors) {
    return false;
  }

  return fields.some((field) => errors[field]);
};

export { hasFieldErrors };
